/**
 * Normalize URLs by removing trailing slashes and protocol
 */
function normalize(url: string): string {
  let normalized = url.toLowerCase();

  if (normalized.endsWith("/")) {
    normalized = normalized.slice(0, -1);
  }

  normalized = normalized.replace(/^https?:\/\//, "");

  return normalized;
}

/**
 * Check if a value is a wildcard pattern
 */
function isWildcardPattern(value: string): boolean {
  return value.includes("*");
}

/**
 * Escape special characters in a string for use in a regular expression
 */
function escapeRegExp(str: string): string {
  return str.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&");
}

/**
 * Convert a wildcard pattern to a regular expression
 */
function wildcardToRegExp(pattern: string): RegExp {
  const escaped = escapeRegExp(pattern);
  const regexPattern = `^${escaped.replace(/\\\*/g, ".*")}$`;
  return new RegExp(regexPattern);
}

/**
 * Match a URL against a pattern with optional wildcard handling
 */
function matchWithOptionalWildcard(url: string, pattern: string): boolean {
  if (isWildcardPattern(pattern)) {
    const regex = wildcardToRegExp(pattern);
    return regex.test(url);
  }
  return url === pattern;
}

/**
 * Check if a URL matches a specific target condition
 */
function matchesTarget(
  url: string,
  target?: { condition?: string; value?: string }
): boolean {
  if (!target) return false;

  const urlLower = normalize(url);
  const targetValueLower = normalize(target.value?.toLowerCase() ?? "");

  switch (target.condition) {
    case "equals":
      return matchWithOptionalWildcard(urlLower, targetValueLower);
    case "notEquals":
      return !matchWithOptionalWildcard(urlLower, targetValueLower);
    case "contains":
      return urlLower.includes(targetValueLower);
    case "notContains":
      return !urlLower.includes(targetValueLower);
    default:
      return false;
  }
}

export const UrlMatcher = {
  matchesTarget,
  normalize,
};
